import barba from '@barba/core';
import barbaPrefetch from '@barba/prefetch';
import Swiper from "swiper/bundle"
import ScrollMagic from "scrollmagic"
import ScrollReveal from "scrollreveal"

import anime from "animejs"

// const preventSettings = () => {
//     // 外部リンクはtarget="_blank"に
//     let site_url = location.protocol + '//' + location.host;
//     if (!href.startsWith(site_url)) {
//         el.setAttribute('target','_blank');
//         return true;
//     }
//     // アンカーリンクであり同一ページでなければbarbaを有効に
//     let url = location.protocol + '//' + location.host + location.pathname;
//     let extract_hash = href.replace(/#.*$/,"");
//     if (href.startsWith(location.protocol + '//' + location.host)) {
//         if (href.indexOf('#') > -1 && extract_hash != url ){
//             return false;
//         }
//     }
//     // 拡張子が該当する場合はtarget="_blank"に
//     if (/\.(xlsx?|docx?|pptx?|pdf|jpe?g|png|gif|svg)/.test(href.toLowerCase())) {
//         el.setAttribute('target','_blank');
//         return true;
//     }
//     // 該当クラスに属していればBarbaを無効に
//     let ignoreClasses = ['outItem'];
//     ignoreClasses.forEach((cls) => {
//         if (el.classList.contains(cls)) {
//             return true;
//         }
//     })
// };

const replaceHead = function(data){
    const head = document.head;
    const newPageRawHead = data.next.html.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0];
    const newPageHead = document.createElement('head');
    newPageHead.innerHTML = newPageRawHead;
 
    const removeHeadTags = [ 
        "meta[name='keywords']",
        "meta[name='description']",
        "meta[property^='og']",
        "meta[name^='twitter']",
        "meta[itemprop]",
        "link[itemprop]",
        "link[rel='prev']",
        "link[rel='next']",
        "link[rel='canonical']"
    ].join(',');
    
    const headTags = head.querySelectorAll(removeHeadTags)
 
    for(let i = 0; i < headTags.length; i++ ){
        head.removeChild(headTags[i]);
    }
    
    const newHeadTags = newPageHead.querySelectorAll(removeHeadTags)
 
    for(let i = 0; i < newHeadTags.length; i++ ){
        head.appendChild(newHeadTags[i]);
    }

    //bodyクラス変更
    let regexp = /\<body.*\sclass=["'](.+?)["'].*\>/gi,
        match = regexp.exec(data.next.html);
    if (!match || !match[1]) {
        // If no body class, remove it
        document.body.setAttribute("class", "");
    } else {
        // Set the new body class
        document.body.setAttribute("class", match[1]);
    }

    //headerクラス変更
    const header = document.getElementById('header');
    let regexHeader = /\<header.*\sid=["'](.+?)["'].*\sclass=["'](.+?)["'].*\>/gi,
        matchH = regexHeader.exec(data.next.html);
    if (!matchH || !matchH[1]) {
        // If no body class, remove it
        header.setAttribute("class", "");
    } else {
        // Set the new body class
        header.setAttribute("class", matchH[1]);
    }
}

barba.hooks.beforeEnter((data) => {
    replaceHead(data);

    //スライドショー
    var myswiper = new Swiper(".mv__innerSlider", {
        effect: "fade",
        centeredSlides: true,
        speed: 1000,
        loop:  true,
        autoplay: {
            delay: 4500,
            disableOnInteraction: false,
        },
        pagination: {
        el: ".swiper-pagination",
        },
        simulateTouch:  false
    });

    var myswiper02 = new Swiper(".sec__buyInnerSlider", {
        slidesPerView: 1,
        spaceBetween: 40,
        speed: 2000,
        loop:  true,
        // autoplay: {
        //     delay: 4500,
        //     disableOnInteraction: false,
        // },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            1024: {
            slidesPerView: 2.5,
            spaceBetween: 60,
            },
        },
    });

    //商品Slide
    var myswiper03 = new Swiper('.buySingle__containerSlideSlider',{
        simulateTouch:  false
    });

    // const thum = document.querySelectorAll('.buySingle__containerSlideThumBox');
    const thums = document.getElementsByClassName('buySingle__containerSlideThumBox')
    const thumLink = document.querySelectorAll('.buySingle__containerSlideThumBoxIn')
    const slideThum =  document.getElementById('slideThum');
    const firstElement = slideThum.firstElementChild;

    firstElement.classList.add('active');

    thumLink.forEach(thumLinkIndex => {
        thumLinkIndex.addEventListener('click', () => {
            const thumLinkIndexPare = thumLinkIndex.parentNode;
            for (let i = 0; i < thums.length; i++){
            thums[i].classList.remove('active');
            }

            var elements = [].slice.call( thums );
            var index = elements.indexOf(thumLinkIndexPare);
            myswiper03.slideTo(index);
            thumLinkIndexPare.classList.add('active');
        });
    });

    // スクロールマジック
    // var controller = new ScrollMagic.Controller();
    // new ScrollMagic.Scene({
    //     triggerElement: ".trigger",
    //     triggerHook: "onLeave",
    // })
    // .setClassToggle("#header", "isFixed") // add class toggle
    // .addTo(controller);

    // ScrollReveal().reveal('.js_scroll', {
    //     duration: 800, // アニメーションの完了にかかる時間
    //     distance: '20px',
    //     viewFactor: 0.2, // 0~1,どれくらい見えたら実行するか
    //     origin: 'bottom',
    //     reset: false
    // });

    //vanillaJS

    const loading = document.getElementById('loading');
    if( localStorage.getItem('disp_popup') ) {
        loading.remove();
    }
});

barba.hooks.afterEnter((data) => {
    // スクロールマジック
    var controller = new ScrollMagic.Controller();
    new ScrollMagic.Scene({
        triggerElement: ".trigger",
        triggerHook: "onLeave",
    })
    .setClassToggle("#header", "isFixed") // add class toggle
    .addTo(controller);

    ScrollReveal().reveal('.js_scroll', {
        duration: 800, // アニメーションの完了にかかる時間
        distance: '20px',
        viewFactor: 0.2, // 0~1,どれくらい見えたら実行するか
        origin: 'bottom',
        reset: false
    });

    const accHeader = document.querySelectorAll('.cmn__accHeader');

    accHeader.forEach(accHeaderIndex => {
        accHeaderIndex.addEventListener('click', () => {
            const accHeaderIndexPare = accHeaderIndex.parentNode;
            accHeaderIndexPare.classList.toggle('open');
        });
    });
});

barba.hooks.afterLeave((data) => {
    controller.destroy(reset);
});

barba.use(barbaPrefetch);

barba.init({
    // prevent: preventSettings,
    transitions: [{
        name: 'page-transition',
        sync:true,
        leave:function(data) {
            const done = this.async();
            // leaveAnimation(data.current.container);
            data.current.container.style.top = -(window.scrollY) + "px";
            data.current.container.classList.add("js-barba__leave");

            window.scrollTo(0,0)
            anime.timeline().add({
                targets : data.current.container,
                opacity: [1,0],
                translateY: [0, '30px'],
                easing: "easeInOutQuad",
                duration : 600,
                // delay: 200,
            }).add({
                easing: 'easeInOutQuad',
                targets: '#transition',
                duration: 250,
                delay: 200,
                scale: [2.5, 0],
                complete:function(){
                    done();
                }
            })
        },
        enter:function(data) {
            const done = this.async();
            anime.timeline().add({
                easing: 'easeInOutQuad',
                targets: '#transition',
                duration: 250,
                delay: 200,
                scale: [0, 2.5],
            }).add({
                targets : data.next.container,
                opacity: [0,1],
                translateY: ['30px', 0],
                easing: "easeInOutQuad",
                duration : 600,
                delay: 200,
                complete:function(){
                    done();
                }
            })
        }
    }]
});
